import { Modal } from '../../../../../components/modal';
import { CONSTANTS } from '../../../../../config/constants';
import { useMerchant } from '../../../../../hooks/useMerchant';
import {
	Detail,
	Item,
} from '../../../../payment-links-3/components/modal-payment/components/detail';
import {
	CancelButton,
	ErrorButtonContainer,
	ErrorHeader,
	ErrorMainSection,
	ErrorSpan,
	ErrorSubtitle,
	ErrorTitle,
	SendEmailButton,
} from '../styles';

export interface ErrorLimitModalProps {
	show: boolean;
	onClose: () => void;
	items: Item[];
}

const ErrorLimitModal = ({ show, onClose, items }: ErrorLimitModalProps) => {
	const { merchantSelected } = useMerchant();
	const mailTo = `mailto:${CONSTANTS.mails.mailTo}`;

	const Subject = `Solicitud para invitar nuevos usuarios a ${merchantSelected?.name}`;

	const infoUser = items
		.filter((item) => item.title != 'Comercio')
		.map((item) => `- ${item.title}: ${item.value}`)
		.join('%0A');

	const body = `Estimados, requiero apoyo para invitar a un nuevo usuario a mi comercio ${merchantSelected?.name}.%0A%0AInformación del usuario:%0A${infoUser}%0A%0A(Aquí puedes añadir todos los usuarios que necesites).%0A%0AMuchas gracias, un saludo.`;

	const mailToText = `${mailTo}?subject=${Subject.replaceAll(' ', '%20')}&body=${body.replaceAll(
		' ',
		'%20',
	)}`;

	return (
		<Modal title="Limite diario alcanzado" show={show} onClose={onClose} type="medium">
			<ErrorMainSection>
				<ErrorHeader>
					<ErrorTitle>No se pudo invitar a este usuario</ErrorTitle>
					<ErrorSubtitle>
						Hoy has sobrepasado el límite de invitaciones diarias. Pero no te preocupes, nuestro
						equipo está listo para ayudarte.
					</ErrorSubtitle>
					<ErrorSubtitle>
						Envíanos tu petición al correo <ErrorSpan>{CONSTANTS.mails.mailTo}</ErrorSpan> para
						invitar a este nuevo usuario y añade los datos de todos los usuarios que necesites.
					</ErrorSubtitle>
				</ErrorHeader>
				<Detail items={items} backgroundColor="#F8F8F8" fontSize="16px" />
				<ErrorButtonContainer>
					<CancelButton onClick={onClose}>Cancelar</CancelButton>
					<SendEmailButton href={mailToText}>Abrir correo</SendEmailButton>
				</ErrorButtonContainer>
			</ErrorMainSection>
		</Modal>
	);
};

export { ErrorLimitModal };
